/**
 * @description: 数字格式化
 * @return {*}
 */
export const numFormat = (num: string | number | null | undefined, digits = 2, empty = '0'): string => {
  if (num === null || num === undefined || num === '') {
    return numFormat(empty, digits)
  }

  const n = Number(num);
  if (Number.isNaN(n)) {
    return numFormat(empty, digits)
  }

  // 固定小数位
  const fixed = n.toFixed(digits);

  // 拆分整数和小数
  const [integer, decimal] = fixed.split('.');

  // 只给整数部分加千分位
  const formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimal ? `${formattedInt}.${decimal}` : formattedInt;
};

/**
 * @description: 数组转化为枚举
 * @return {*}
 */
export const arrayToEnum = (data: Record<string, any>[], key = { label: 'label', value: 'value' }) => {
  return data.reduce((acc, cur) => {
    acc[cur[key.value]] = cur[key.label];
    return acc;
  }, {});
};

/**
 * @description: 文件大小格式化
 * @param {number} size
 * @param {number} unit/数据单位默认为B('B', 'K', 'M', 'G')
 * @return {*}
 */
export const fileSizeFormat = (size: number | string, unit = 'B') => {
  let fileSize = Number(size || 0)
  if (unit.toLowerCase() === 'k') {
    fileSize = fileSize * 1024
  }
  if (unit.toLowerCase() === 'm') {
    fileSize = fileSize * 1024 * 1024
  }
  if (unit.toLowerCase() === 'g') {
    fileSize = fileSize * 1024 * 1024 * 1024
  }
  if (!fileSize) {
    return ''
  }
  if (fileSize < 1024) {
    return `${fileSize}Bytes`
  }
  const kb = Number((fileSize / 1024).toFixed(1))
  if (kb < 1024) {
    return `${kb}KB`
  }
  const mb = Number((fileSize / 1024 / 1024).toFixed(1))
  if (mb < 1024) {
    return `${mb}MB`
  }
  const gb = Number((fileSize / 1024 / 1024 / 1024).toFixed(1))
  return `${gb}GB`
}

/**
 * @description: 格式化数字显示文本，为-1时为不限
 * @param {number} num
 * @param {number} digits
 * @return {*}
 */
export const numLabelFormat = (num?: number | string, digits: number = 2) => {
  if (num ?? true) {
    if (num === -1) {
      return '不限'
    }
    return numFormat(num, digits)
  }
  return '不限'
}

/**
 * @description: 格式化数字，为-1时为null
 * @param {number} num
 * @param {number} empty
 * @return {*}
 */
export const numValueFormat = (num?: number | string, empty: number | null = null) => {
  if (num ?? true) {
    if (num === -1) {
      return empty
    }
    return Number(num)
  }
  return empty
}